export default {
  // OSS上传签名
  OSSINFO: {
    host: ""
  },
  FileName: '',
  OSSINFONew: {
    
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/Common/state.js